<template>
  <div id="app">
    <common-js v-if="!isDelete" />
    <router-view />
    <GuideCourse v-if="isInSconedIframe && !isAutoLogin && !hideTmsCode && !isC9BSCallCar" />
    <!-- 企微客服 -->
    <WxServiceNew v-if="isInSconedIframe && !isAutoLogin && !hideTmsCode" />
    <InsuranceBtn v-if="isInSconedIframe && !isAutoLogin && !hideTmsCode" />
  </div>
</template>

<style>
#app {
  font-family: '微软雅黑', '宋体', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.lq-page-content {
  height: 100%;
}
/* 时间控件图标样式 */
.ExtractTimeDate .l-trigger-icon {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/dataSelectConter/Dayicon.png');
  background-size: 100% 100%;
}
/* 公版低版本html的浏览器默认样式，vue页面样式尽量和公版保持一致 */
/* input:not([type="image" i]){
  box-sizing: border-box;
} */
</style>
<script>
import CommonJs from '@/components/commonJs'
import account from '@/router/account' //所有登录页
import GuideCourse from '@/components/HomeRightIcons/GuideCourse.vue'
import WxServiceNew from '@/components/HomeRightIcons/WxServiceNew.vue'
import InsuranceBtn from '@/components/HomeRightIcons/InsuranceBtn.vue'

const deleteCommonJsComponent = () => {
  const pathname = location.pathname.replace(window.__lq_base_url, '')
  const pathnameList = [
    '/',
    '/home/index',
    '/homeV2/index',
    '/home', // 首页
    '/homeV2',
    '/loadpage',
    '/loadpage/index', // 加载页
    '/account',
    ...account.map(item => item.path) // 登录页
  ]
  return pathnameList.some(item => item.toLocaleLowerCase() == pathname.toLocaleLowerCase())
}
export default {
  components: { CommonJs, GuideCourse, InsuranceBtn, WxServiceNew },
  data() {
    const u = window.LQAPI && window.LQAPI.getUserInfo()
    const TMSCode = u && u.TMSCode
    return {
      isDelete: deleteCommonJsComponent(),
      isInSconedIframe: false,
      isAutoLogin: sessionStorage.getItem('proxyOperateKey'),
      hideTmsCode: ['98029'].indexOf(TMSCode) != -1,
      isC9BSCallCar: $.getcookie('TMSversion') === window.LQAPI.C9BS_CALL_CAR
    }
  },
  created() {
    const current = new Date().getTime()
    window.__lq__lib_track__api.monitorLoadDuration({
      duration: current - window.__lq__lib_track__api.__html_load_start,
      pagetype: 'app',
      url: window.location.pathname,
      current,
      start: window.__lq__lib_track__api.__html_load_start
    })
  },
  mounted() {
    var tt = setTimeout(() => {
      clearTimeout(tt)
      this.isInSconedIframe = self != top && parent == top
      if (frameElement && frameElement.dialog) {
        // 在弹框中打开的iframe不要加载浮动图标
        this.isInSconedIframe = false
      }
      var pathname = window.location.pathname
      if (pathname.indexOf('/printProblem/Index') > -1 || pathname.indexOf('/weCom/weCom') > -1) {
        $('.float-btn').css({ display: 'none' })
      }
    }, 1500)
    this.$nextTick(() => {
      $('input').attr('autocomplete', 'off')
      // 公版处理：给body挂上自定义classname
      var tmsCode = $.getCookie('tmsbstmscode2') || $.getcookie('tmsbstmscode');
      if (tmsCode) {
        $('body').addClass('body-' + tmsCode);
      }
    })

  }
}
</script>
